import { Dialog, Snackbar } from "@mui/material";
import Alert from '@mui/material/Alert';
import React, { useContext, useState } from "react";
import BSSDataContext from "../contexts/BSSDataContext";
import useBSSErrorManager from "../hooks/useBSSErrorManager";
import useBSSLogger from "../hooks/useBSSLogger";
import __t from "../lib/traduzioni";
import BSSDialog from "./form/BSSDialog";
import BSSSnackbar from "./form/BSSSnackbar";

const {logger} = useBSSLogger();

const defaultError = {message: null, show: false}


const BSSErrorBar = ({SnackbarProps = {}, AlertProps = {}}) => {

    const [error, setError] = useState(defaultError);
    useBSSErrorManager({setError});

    const {shadowBody} = useContext(BSSDataContext);

    logger.finest("bss error bar", error)

    let errori = error?.message ?? [];
    if(!Array.isArray(errori) && errori.length){
        errori = [errori]
    } 

    const statusError = error?.originalError?.response?.status ?? null;

    if((errori.length === 0 || errori instanceof ArrayBuffer) && statusError !== null){
        errori = [
            {
                message: __t(`error_${(""+statusError).substring(0, 1)}xx`)
            }
        ]
    }

    return (
        <BSSDialog style={{ zIndex: 99999999 }} open={error.show && Array.isArray(errori)} 
            onClose={e => setError(defaultError)} >
            <Alert onClose={e => setError(defaultError)} severity="error" {...AlertProps}>
                
                {/* <ReactJson src={error?.originalError?.response ?? null} /> */}

                <ul>
                    {errori.map((errore, indiceerrore) => (
                        <li key={indiceerrore}>
                            {errore.message ?? errore ?? __t("oopserror")}
                        </li>
                    ))}                
                </ul>
                
            </Alert>
        </BSSDialog>
    )

}

export default BSSErrorBar